/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this file will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // ================================================================
  // Cart rewards + free-gift progress bar
  // ----------------------------------------------------------------
  // We render three types of rewards in the cart drawer / cart page:
  //   1. Free tote at $150 subtotal      (fg)
  //   2. Free Resistance Band at 2 BAMBActive items      (oa)
  //   3. Buy 4 sale items → cheapest free (Shopify checkout)     (ob)
  //
  // (1) and (2) become a "Claim your free X" button when unlocked.
  // Clicking dispatches the theme's own cart:add-to-cart event, so
  // the theme handles the POST /cart/add.js and the drawer rebuild.
  // No auto-add and no reconciler — a customer opts in per reward.
  // Shopify's Automatic BXGY discount handles $0 pricing at checkout.
  // Note: Shopify only applies one product discount per checkout, so
  // if a customer claims multiple, only the biggest saving lands.
  //
  // (3) is informational only. Shopify's BXGY handles both the price
  // adjustment and the cheapest-free selection at checkout.
  // ================================================================

  var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)\.js/;
  var FG_PROP = '_free_gift';
  var OA_PROP_KEY = '_free_gift_offer';
  var OA_PROP_VALUE = 'offer_a';

  function sharedGetCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function(r) { return r.json(); });
  }

  // Dispatch the theme's own cart:add-to-cart event. The theme's
  // addToCart builds `id=${data.id}` as the urlencoded body — we
  // append `&properties[key]=value` onto the id so properties survive.
  function themeAddWithProps(variantId, propKey, propValue) {
    var idPayload = variantId + '&properties[' + encodeURIComponent(propKey) + ']=' + encodeURIComponent(propValue);
    document.documentElement.dispatchEvent(new CustomEvent('cart:add-to-cart', {
      bubbles: true,
      detail: { data: { id: idPayload, quantity: 1 } }
    }));
  }

  // ---------- Progress bar (from data attrs on [data-fg-bar]) ----------

  function fgBar() { return document.querySelector('[data-fg-bar]'); }

  function fgConfig() {
    var el = fgBar();
    if (!el) return null;
    return {
      giftCents: parseInt(el.getAttribute('data-fg-gift-threshold'), 10),
      shipCents: parseInt(el.getAttribute('data-fg-ship-threshold'), 10),
      variantId: parseInt(el.getAttribute('data-fg-variant-id'), 10),
      productName: el.getAttribute('data-fg-product-name') || '',
      giftThresholdDisplay: el.getAttribute('data-fg-gift-threshold-display') || '',
      shipThresholdDisplay: el.getAttribute('data-fg-ship-threshold-display') || '',
      belowMsg: el.getAttribute('data-fg-below-msg') || '',
      unlockedMsg: el.getAttribute('data-fg-unlocked-msg') || '',
      bothMsg: el.getAttribute('data-fg-both-msg') || '',
      currencyCode: el.getAttribute('data-fg-currency-code') === 'true'
    };
  }

  function fgFormatMoney(cents, useCurrencyCode) {
    if (window.themeCurrency && typeof window.themeCurrency.formatMoney === 'function' && window.theme) {
      var fmt = useCurrencyCode ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
      if (fmt) return window.themeCurrency.formatMoney(cents, fmt).replace('.00', '');
    }
    return '$' + (cents / 100).toFixed(2).replace('.00', '');
  }

  function fgFillTokens(template, tokens) {
    var out = template;
    for (var key in tokens) {
      if (Object.prototype.hasOwnProperty.call(tokens, key)) {
        var re = new RegExp('\\|\\|' + key + '\\|\\|', 'g');
        out = out.replace(re, tokens[key]);
      }
    }
    return out;
  }

  // ---------- Cart introspection helpers ----------

  function isFreeTote(item) {
    return item.properties && item.properties[FG_PROP] === 'true';
  }

  function isFreeBand(item) {
    return item.properties && item.properties[OA_PROP_KEY] === OA_PROP_VALUE;
  }

  function fgQualifyingSubtotal(cart) {
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (isFreeTote(item) || isFreeBand(item)) continue;
      total += item.line_price;
    }
    return total;
  }

  // Any presence of the freebie variant (however it got into the cart) hides
  // the claim button — no double-add. Auto-removal is stricter (see findFreebieKey):
  // it only removes freebies WE added (property-tagged), so a manually-added tote
  // stays put.
  function hasFreeToteInCart(cart, variantId) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === variantId) return true;
    }
    return false;
  }

  function hasFreeBandInCart(cart, variantId) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === variantId) return true;
    }
    return false;
  }

  // Skip ALL freebies (tote and band) so adding a freebie can never satisfy
  // another offer's threshold — otherwise a tote that happens to also be in
  // the BAMBActive collection would flip Offer A eligibility and auto-remove itself.
  function oaEligibleCount(cart, cfg) {
    var idSet = {};
    for (var i = 0; i < cfg.productIds.length; i++) idSet[cfg.productIds[i]] = true;
    var count = 0;
    for (var j = 0; j < cart.items.length; j++) {
      var item = cart.items[j];
      if (isFreeTote(item) || isFreeBand(item)) continue;
      if (idSet[item.product_id]) count += item.quantity;
    }
    return count;
  }

  function obSaleCount(cart, cfg) {
    if (!cfg || !cfg.productIds || !cfg.productIds.length) return 0;
    var idSet = {};
    for (var i = 0; i < cfg.productIds.length; i++) idSet[cfg.productIds[i]] = true;
    var count = 0;
    for (var j = 0; j < cart.items.length; j++) {
      var item = cart.items[j];
      if (isFreeTote(item) || isFreeBand(item)) continue;
      if (idSet[item.product_id]) count += item.quantity;
    }
    return count;
  }

  // ---------- UI update ----------

  function fgUpdateBarUI(cart, cfg) {
    var el = fgBar();
    if (!el || !cfg) return;

    var qualifying = fgQualifyingSubtotal(cart);
    var fill = Math.min(qualifying, cfg.shipCents);
    var fillPct = (fill / cfg.shipCents) * 100;
    var giftMarkerPct = (cfg.giftCents / cfg.shipCents) * 100;

    var fillEl = el.querySelector('[data-fg-fill]');
    if (fillEl) fillEl.style.width = fillPct + '%';

    var giftMarker = el.querySelector('[data-fg-marker="gift"]');
    if (giftMarker) {
      giftMarker.style.left = giftMarkerPct + '%';
      giftMarker.classList.toggle('is-reached', qualifying >= cfg.giftCents);
    }
    var shipMarker = el.querySelector('[data-fg-marker="ship"]');
    if (shipMarker) shipMarker.classList.toggle('is-reached', qualifying >= cfg.shipCents);

    var msgEl = el.querySelector('[data-fg-message]');
    if (msgEl) {
      var baseTokens = {
        'product': cfg.productName,
        'gift_threshold': cfg.giftThresholdDisplay,
        'ship_threshold': cfg.shipThresholdDisplay
      };
      var msg;
      if (qualifying >= cfg.shipCents) {
        msg = fgFillTokens(cfg.bothMsg, baseTokens);
      } else if (qualifying >= cfg.giftCents) {
        baseTokens.amount = fgFormatMoney(cfg.shipCents - qualifying, cfg.currencyCode);
        msg = fgFillTokens(cfg.unlockedMsg, baseTokens);
      } else {
        baseTokens.amount = fgFormatMoney(cfg.giftCents - qualifying, cfg.currencyCode);
        msg = fgFillTokens(cfg.belowMsg, baseTokens);
      }
      msgEl.textContent = msg;
    }
  }

  // Auto-add / auto-remove freebies independently per offer. Shopify combinations
  // are set to "Multiple product discounts can apply per order", so any eligible
  // offer's freebie is added to the cart. When a customer clicks Remove we set a
  // session flag so we don't re-add on the next cart update — the flag clears
  // when eligibility drops and returns (a real cart change), giving them the
  // freebie again on the next crossing.
  var prevEligible = { fg: false, oa: false };
  var addInFlight = { fg: false, oa: false };

  function removedFlagKey(offer) { return 'bamba_reward_removed_' + offer; }
  function isRemovedFlag(offer) {
    try { return sessionStorage.getItem(removedFlagKey(offer)) === '1'; } catch (e) { return false; }
  }
  function setRemovedFlag(offer, val) {
    try {
      if (val) sessionStorage.setItem(removedFlagKey(offer), '1');
      else sessionStorage.removeItem(removedFlagKey(offer));
    } catch (e) {}
  }

  function updateRewardsUI(cart) {
    var cfg = fgConfig();
    var oaCfg = window.oaOfferA;
    var obCfg = window.offerB;

    var fgEligible = false, fgInCart = false;
    if (cfg) {
      fgEligible = fgQualifyingSubtotal(cart) >= cfg.giftCents;
      fgInCart = hasFreeToteInCart(cart, cfg.variantId);
    }
    var oaEligible = false, oaInCart = false;
    if (oaCfg && oaCfg.enabled) {
      oaEligible = oaEligibleCount(cart, oaCfg) >= (oaCfg.minQty || 2);
      oaInCart = hasFreeBandInCart(cart, oaCfg.variantId);
    }
    var obEligible = false;
    if (obCfg && obCfg.enabled) {
      obEligible = obSaleCount(cart, obCfg) >= (obCfg.minQty || 4);
    }

    // Clear user-removed flag on false→true eligibility transition (they crossed the threshold anew).
    if (fgEligible && !prevEligible.fg) setRemovedFlag('fg', false);
    if (oaEligible && !prevEligible.oa) setRemovedFlag('oa', false);
    prevEligible.fg = fgEligible;
    prevEligible.oa = oaEligible;

    // Priority: Offer B (sale, cheapest free) wins over Offer A (band) when both eligible.
    // Shopify only applies ONE product BXGY discount per order, so we suppress the band
    // when sale is also eligible — sale is the higher-value discount.
    var oaAllowed = oaEligible && !obEligible;

    // Auto-remove: eligibility dropped, OR band is suppressed by sale.
    if (fgInCart && !fgEligible) {
      var fgRmKey = findFreebieKey(cart, FG_PROP, 'true', cfg.variantId);
      if (fgRmKey) { themeRemoveByKey(fgRmKey); fgInCart = false; }
    }
    if (oaInCart && !oaAllowed) {
      var oaRmKey = findFreebieKey(cart, OA_PROP_KEY, OA_PROP_VALUE, oaCfg.variantId);
      if (oaRmKey) { themeRemoveByKey(oaRmKey); oaInCart = false; }
    }

    // Auto-add: eligible (and allowed), not in cart, user hasn't opted out this session.
    if (cfg && fgEligible && !fgInCart && !isRemovedFlag('fg') && !addInFlight.fg) {
      addInFlight.fg = true;
      themeAddWithProps(cfg.variantId, FG_PROP, 'true');
      setTimeout(function() { addInFlight.fg = false; }, 2000);
    }
    if (oaCfg && oaCfg.enabled && oaAllowed && !oaInCart && !isRemovedFlag('oa') && !addInFlight.oa) {
      addInFlight.oa = true;
      themeAddWithProps(oaCfg.variantId, OA_PROP_KEY, OA_PROP_VALUE);
      setTimeout(function() { addInFlight.oa = false; }, 2000);
    }

    // Enforce qty=1 on freebie lines — never allow multi-add.
    capFreebieQty(cart, cfg && cfg.variantId);
    capFreebieQty(cart, oaCfg && oaCfg.enabled && oaCfg.variantId);

    // Hide qty +/− controls on freebie cart lines only. Non-freebie lines untouched.
    var freebieIds = [];
    if (cfg && cfg.variantId) freebieIds.push(cfg.variantId);
    if (oaCfg && oaCfg.enabled && oaCfg.variantId) freebieIds.push(oaCfg.variantId);
    hideQtyForFreebieLines(freebieIds);

    if (cfg) fgUpdateBarUI(cart, cfg);

    var fgAdded = document.querySelector('[data-reward-added="fg"]');
    if (fgAdded) fgAdded.hidden = !fgInCart;
    var oaAdded = document.querySelector('[data-reward-added="oa"]');
    if (oaAdded) oaAdded.hidden = !oaInCart;

    var obMsg = document.querySelector('[data-reward-msg="ob"]');
    if (obMsg) obMsg.hidden = !obEligible;

    // Footer note: show only when band or sale offer is active/eligible (the "1 discount per order" rule).
    // Tote is separate (free product, not a discount) so its presence alone doesn't trigger the note.
    var note = document.querySelector('[data-reward-note]');
    if (note) note.hidden = !(oaInCart || oaEligible || obEligible);
  }

  function capFreebieQty(cart, variantId) {
    if (!variantId) return;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.variant_id === variantId && it.quantity > 1) {
        fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: it.key, quantity: 1 })
        });
        return;
      }
    }
  }

  function hideQtyForFreebieLines(variantIds) {
    if (!variantIds || !variantIds.length) return;
    for (var i = 0; i < variantIds.length; i++) {
      var vidEls = document.querySelectorAll('[data-vid="' + variantIds[i] + '"]');
      for (var j = 0; j < vidEls.length; j++) {
        var line = vidEls[j].closest('[data-item]');
        if (!line) continue;
        var qty = line.querySelector('.cart__quantity');
        if (qty) qty.style.display = 'none';
        // Also hide the native Remove link — otherwise removing there bypasses our
        // "user removed" flag and the freebie auto-re-adds on the next refresh.
        var nativeRemove = line.querySelector('.cart-item__remove');
        if (nativeRemove) nativeRemove.style.display = 'none';
      }
    }
  }

  // Dispatch theme's update-cart on the [data-item] for a freebie, with qty 0.
  // Uses the line-item KEY (Shopify hash like "12345:hash"), not the numeric line,
  // per theme.js's matchKeys logic.
  function themeRemoveByKey(itemKey) {
    if (!itemKey) return;
    var itemEls = document.querySelectorAll('[data-item]');
    for (var i = 0; i < itemEls.length; i++) {
      // Broadcast puts the key on data-id (from the theme's remove button's data-id attr)
      var removeBtn = itemEls[i].querySelector('[data-id="' + itemKey + '"]');
      if (removeBtn) {
        itemEls[i].dispatchEvent(new CustomEvent('update-cart', {
          bubbles: true,
          detail: { id: itemKey, quantity: 0, valueIsEmpty: true }
        }));
        return true;
      }
    }
    // Fallback: POST /cart/change.js directly by id (key)
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: 0 })
    }).then(function() {
      // Nudge theme to rebuild via getCart() (no direct hook — refresh triggers via interceptor)
      setTimeout(refresh, 200);
    });
    return true;
  }

  function findFreebieKey(cart, propKey, propValue, variantId) {
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.variant_id !== variantId) continue;
      if (it.properties && it.properties[propKey] === propValue) return it.key;
    }
    return null;
  }

  // ---------- Wire up ----------

  var lastRefresh = 0;
  function refresh() {
    var now = Date.now();
    if (now - lastRefresh < 200) return;
    lastRefresh = now;
    sharedGetCart().then(updateRewardsUI).catch(function(err) {
      if (window.console) console.warn('[cart-rewards]', err);
    });
  }

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var result = origFetch.apply(this, arguments);
      if (CART_MUTATION_RE.test(url)) {
        result.then(function() { setTimeout(refresh, 250); }, function() {});
      }
      return result;
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    setTimeout(refresh, 0);
  }
  document.addEventListener('cart:open', refresh);

  document.addEventListener('click', function(e) {
    var rmBtn = e.target.closest('[data-reward-remove]');
    if (rmBtn && !rmBtn.disabled) {
      e.preventDefault();
      var rmType = rmBtn.getAttribute('data-reward-remove');
      var rmVariantId = parseInt(rmBtn.getAttribute('data-variant-id'), 10);
      if (!rmVariantId) return;
      rmBtn.disabled = true;
      rmBtn.textContent = 'Removing...';
      // Suppress auto-add for this session (until eligibility drops + returns).
      setRemovedFlag(rmType, true);
      sharedGetCart().then(function(cart) {
        var key = null;
        if (rmType === 'fg') key = findFreebieKey(cart, FG_PROP, 'true', rmVariantId);
        else if (rmType === 'oa') key = findFreebieKey(cart, OA_PROP_KEY, OA_PROP_VALUE, rmVariantId);
        if (key) themeRemoveByKey(key);
        else { rmBtn.disabled = false; rmBtn.textContent = 'Remove'; }
      });
    }
  });

  // ================================================================
  // Countdown bar (sections/countdown-bar.liquid)
  // ================================================================

  function cdInitBar(bar) {
    var endTs = parseInt(bar.getAttribute('data-cd-end'), 10) * 1000;
    if (!endTs || isNaN(endTs)) return;

    var daysEl = bar.querySelector('[data-cd-days] .cd-bar__pill-value');
    var hoursEl = bar.querySelector('[data-cd-hours] .cd-bar__pill-value');
    var minsEl = bar.querySelector('[data-cd-minutes] .cd-bar__pill-value');
    var secsEl = bar.querySelector('[data-cd-seconds] .cd-bar__pill-value');
    if (!daysEl || !hoursEl || !minsEl || !secsEl) return;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var diff = endTs - Date.now();
      if (diff <= 0) {
        clearInterval(interval);
        bar.parentNode && bar.parentNode.removeChild(bar);
        return;
      }
      var d = Math.floor(diff / 86400000); diff -= d * 86400000;
      var h = Math.floor(diff / 3600000);  diff -= h * 3600000;
      var m = Math.floor(diff / 60000);    diff -= m * 60000;
      var s = Math.floor(diff / 1000);
      daysEl.textContent  = pad(d);
      hoursEl.textContent = pad(h);
      minsEl.textContent  = pad(m);
      secsEl.textContent  = pad(s);
    }

    tick();
    var interval = setInterval(tick, 1000);
  }

  function cdInitAll() {
    var bars = document.querySelectorAll('[data-cd-bar]');
    for (var i = 0; i < bars.length; i++) cdInitBar(bars[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cdInitAll);
  } else {
    cdInitAll();
  }

  // ================================================================
  // Platmart swatches — collapse to N per row with "+X more"       [PL-SWATCH-COLLAPSE]
  // ----------------------------------------------------------------
  // Change SWATCHES_DESKTOP / SWATCHES_MOBILE below to control how
  // many swatches show before the "+X more" toggle. Set either to a
  // very large number (e.g. 999) to effectively disable that breakpoint.
  // Companion CSS in assets/custom.css — search pl-swatches__more.
  // ================================================================
  var SWATCHES_DESKTOP = 7;
  var SWATCHES_MOBILE  = 4;

  function plsInit(container) {
    if (container.dataset.plsCollapseInit) return;
    container.dataset.plsCollapseInit = '1';

    var swatches = container.querySelectorAll('.pl-swatches__link');
    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    var visible = isMobile ? SWATCHES_MOBILE : SWATCHES_DESKTOP;
    var hidden = swatches.length - visible;
    if (hidden <= 0) return;

    var labelExpand = '+' + hidden + ' more';
    var labelCollapse = '− Show less';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pl-swatches__more';
    btn.textContent = labelExpand;
    btn.setAttribute('aria-label', 'Show ' + hidden + ' more colours');
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function() {
      var expanded = container.classList.toggle('is-expanded');
      btn.textContent = expanded ? labelCollapse : labelExpand;
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.setAttribute('aria-label', expanded ? 'Show fewer colours' : 'Show ' + hidden + ' more colours');
    });
    container.appendChild(btn);
  }

  function plsBoot() {
    var containers = document.querySelectorAll('.pl-swatches__container');
    for (var i = 0; i < containers.length; i++) plsInit(containers[i]);
  }

  // Platmart mounts asynchronously — try immediately + poll for ~5s.
  plsBoot();
  var plsAttempts = 0;
  var plsInterval = setInterval(function() {
    plsBoot();
    if (++plsAttempts >= 20) clearInterval(plsInterval);
  }, 250);

  // ================================================================
  // Final-sale note info-icon tooltip — click to open, outside-click
  // or Escape to close. Companion CSS: .product__final-sale-note__info
  // (hidden by default; shown when .is-open class is present).
  // ================================================================
  function closeAllFinalSaleTooltips() {
    var opens = document.querySelectorAll('.product__final-sale-note__info.is-open');
    for (var i = 0; i < opens.length; i++) {
      opens[i].classList.remove('is-open');
      opens[i].setAttribute('aria-expanded', 'false');
    }
  }
  document.addEventListener('click', function(e) {
    var closeBtn = e.target.closest ? e.target.closest('[data-close-tooltip]') : null;
    if (closeBtn) {
      closeAllFinalSaleTooltips();
      e.stopPropagation();
      return;
    }
    var inTooltip = e.target.closest ? e.target.closest('.product__final-sale-note__tooltip') : null;
    if (inTooltip) return;
    var info = e.target.closest ? e.target.closest('.product__final-sale-note__info') : null;
    var opens = document.querySelectorAll('.product__final-sale-note__info.is-open');
    for (var i = 0; i < opens.length; i++) {
      if (opens[i] !== info) {
        opens[i].classList.remove('is-open');
        opens[i].setAttribute('aria-expanded', 'false');
      }
    }
    if (info) {
      var nowOpen = info.classList.toggle('is-open');
      info.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
    }
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeAllFinalSaleTooltips();
    if (e.key === 'Enter' || e.key === ' ') {
      var closeBtn = e.target.closest ? e.target.closest('[data-close-tooltip]') : null;
      if (closeBtn) {
        e.preventDefault();
        closeAllFinalSaleTooltips();
      }
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
